import React, { useEffect } from 'react';

import useScript from '../../../helpers/useScript';

const HUBSPOT_REQUIRED_CSS =
  '.hs_error_rollup {display: none;} .hs-error-msg {margin-top: 5px;} .hs-input { width: 100%; max-width: initial; }';

declare global {
  interface Window {
    hbspt: any;
  }
}

interface IHubspotForm {
  formId: string;
  customCss?: boolean;
}

const HubspotForm = ({ formId, customCss }: IHubspotForm) => {
  const scriptStatus = useScript('https://js.hsforms.net/forms/v2.js');

  const createForm = () => {
    window.hbspt.forms?.create({
      portalId: '7444014',
      formId: formId,
      target: '#hubspotForm',
      cssRequired: HUBSPOT_REQUIRED_CSS,
      css: customCss ? '' : undefined,
      cssClass: customCss ? 'customHubspotForm' : undefined,
      onFormReady: function ($form: { elements: { [x: string]: any } }) {
        const gclid = sessionStorage.getItem('gclid');
        const googleClickIdInput = $form.elements['google_click_id'];
        if (gclid && googleClickIdInput) googleClickIdInput.value = gclid;
      },
    });
  };

  useEffect(() => {
    if (typeof window !== `undefined`) {
      if (scriptStatus === 'ready' && window.hbspt) {
        createForm();
      }
    }
  }, [formId, scriptStatus]);

  return <div id="hubspotForm" className="hubspotForm" />;
};

export default HubspotForm;
